const Card4 = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="scale-110"
    >
      <circle cx="28" cy="28" r="28" fill="white" />
      <path
        d="M28 42C20.2802 42 14 35.7198 14 28C14 20.2802 20.2802 14 28 14C35.7198 14 42 20.2802 42 28C42 35.7198 35.7198 42 28 42ZM31.9632 32.4368L29.1667 27.6815V19.8333H26.8333V28.3173L29.9518 33.6187L31.9643 32.4357L31.9632 32.4368Z"
        fill="#009E3E"
      />
    </svg>
  );
};

export default Card4;
